import styles from "../../styles/Navigation.module.css";

export default function StageSelector({ section, stage, sectionUnitLabel, handleStage, stageCompletionStatus }) {
    return (
        <>
            {/* Passage buttons commented out since we now have IELTS-style navigation with parts */}
            {/* {(section != "writing") &&
                (
                    <div className="passage-buttons" style={{ display: "flex", gap: "8px", justifyContent: "center", width: "100%" }}>
                        <button onClick={() => handleStage(1)} className={`${stageCompletionStatus[1] ? styles.passageDone : ""} 
                            ${stage === 1 ? styles.passageSelected : ""}`}>{sectionUnitLabel.toUpperCase()} 1</button>
                        <button onClick={() => handleStage(2)} className={`${stageCompletionStatus[2] ? styles.passageDone : ""} 
                            ${stage === 2 ? styles.passageSelected : ""}`}>{sectionUnitLabel.toUpperCase()} 2</button>
                        <button onClick={() => handleStage(3)} className={`${stageCompletionStatus[3] ? styles.passageDone : ""} 
                            ${stage === 3 ? styles.passageSelected : ""}`}>{sectionUnitLabel.toUpperCase()} 3</button>
                        {section === "listening" && (
                            <button onClick={() => handleStage(4)}
                                className={`${stageCompletionStatus[4] ? styles.passageDone : ""} 
                                ${stage === 4 ? styles.passageSelected : ""}`}>
                                {sectionUnitLabel.toUpperCase()} 4
                            </button>
                        )}
                    </div>
                )
            } */}
        </>
    );
}
